import { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";
import { useNavigate, useParams } from "react-router-dom";
import { Issues, expert } from "../../Config/Expert";
import { MultiSelect } from "react-multi-select-component";
import { BookingDetails } from "../../Config/Booking";
import ExpertDataService from "../../services/Expert";
import Select from "react-select";
import { FormControl, FormLabel, Switch, useToast } from "@chakra-ui/react";
import { DateTime } from "luxon";
export const EditProvisionalBooking = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { id } = useParams();

  // Provisional bookings may be back-dated, but only as far back as the first
  // day of the previous calendar month. e.g. any day in Sep -> min is Aug 1;
  // on Oct 1 the window rolls forward to Sep 1.
  const minSessionDate = DateTime.now()
    .setZone("Asia/Kolkata")
    .startOf("month")
    .minus({ months: 1 })
    .toFormat("yyyy-MM-dd");

  const token = localStorage.getItem("logged_in_user_token");
  const loggedInUserEmail = localStorage.getItem("logged_in_email");

  const [symptoms, setSymptoms] = useState<any>([]);
  const [expertList, setExpertList] = useState<any>([]);
  const [bookingDate, setBookingDate] = useState("");
  const [isCorporate, setIsCorporate] = useState("");
  const [source, setSource] = useState("");
  const [sessionDate, setSessionDate] = useState("");
  const [sessionCount, setSessionCount] = useState("");
  const [bookingPostStatus, setBookingPostStatus] = useState("");
  const [bookingTime, setBookingTime] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [paymentInformation, setPaymentInformation] = useState({
    amount: "0",
    payment_id: "PORTAL_BOOKING",
  });
  const [leadInformation, setLeadInformation] = useState({
    uuid: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const [expertInformation, setExpertInformation] = useState({
    uuid: "",
    full_name: "",
    role: "",
  });
  const [cartInformation, setCartInformation] = useState({
    promocode: "",
    original_price: "",
    final_price: "",
    subscription: false,
    pro: false,
  });
  const [subscriptionInformation, setSubscriptionInformation] = useState({
    session_count: "",
    price: "",
    subscription_sequence: 0,
    subscription_booking_id: "",
  });
  const [manoProInformation, setManoProInformation] = useState({
    term_length: "",
    price: "",
    module: "",
  });

  const [therapyPlusInformation, setTherapyPlusInformation] = useState({
    term_length: "",
    price: "",
  });
  const [therapyInformation, setTherapyInformation] = useState({
    gender: "",
    age: 0,
    symptoms: [],
    notes: "",
  });
  const [physicalInformation, setphysicalInformation] = useState({
    address: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
    pin_code: "",
  });

  const handleLeadChange = (e: any) => {
    setLeadInformation({ ...leadInformation, [e.target.name]: e.target.value });
  };

  const handleCartChange = (e: any) => {
    let value = e.target.value;
    if (e.target.name === "subscription" || e.target.name === "pro") {
      value = convertToBoolean(value);
    }
    setCartInformation({ ...cartInformation, [e.target.name]: value });
  };

  const convertDateFormat = (inputDate: any) => {
    if (inputDate) {
      console.log("inputDate", inputDate);
      const parts = inputDate.split("/");
      console.log("parts", parts);
      const month = parts[0].padStart(2, "0");
      const day = parts[1].padStart(2, "0");
      const year = parts[2];
      const newDateFormat = `${year}-${month}-${day}`;
      console.log("newDateFormat", newDateFormat);
      return newDateFormat;
    }
    return "";
  };
  const convertTo24HourFormat = (timeString: string) => {
    if (timeString) {
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");

      let newHours = parseInt(hours, 10);
      if (period === "PM" && newHours !== 12) {
        newHours += 12;
      } else if (period === "AM" && newHours === 12) {
        newHours = 0;
      }

      const newTime = `${newHours.toString().padStart(2, "0")}:${minutes}`;
      return newTime;
    }
    return "";
  };

  const handleTherapyChange = (e: any) => {
    let value = e.target.value;
    if (e.target.name === "age") {
      value = Number(value);
    }
    setTherapyInformation({
      ...therapyInformation,
      [e.target.name]: value,
    });
  };
  const formattedTime = (inputTime: string) => {
    const parts = inputTime.split(":");

    if (parts.length === 2) {
      let hour = parseInt(parts[0], 10);
      const minute = parts[1];
      let meridiem = "AM";

      if (hour >= 12) {
        meridiem = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      if (hour === 0) {
        hour = 12;
      }

      const formattedTime = `${hour}:${minute} ${meridiem}`;

      return formattedTime;
    }
    return "";
  };
  const formattedDate = (inputDate: string) => {
    const parts = inputDate.split("-");
    console.log("parts", parts);
    if (parts.length === 3) {
      const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
      console.log("formattedDate", formattedDate);
      return formattedDate;
    }
    return "";
  };
  const handleBookingDateChange = (e: any) => {
    setBookingDate(e.target.value);
  };
  const handleBookingTimeChange = (e: any) => {
    setBookingTime(e.target.value);
  };
  const handleSessionDateChange = (e: any) => {
    setSessionDate(e.target.value);
  };
  const handleSessionTimeChange = (e: any) => {
    setSessionTime(e.target.value);
  };
  const [bookingDetails, setBookingDetails] = useState<any>(BookingDetails);

  const handleChange = (e: any) => {
    let value = e.target.value;

    setBookingDetails({
      ...bookingDetails,
      [e.target.name]: value,
    });
  };
  const convertToBoolean = (value: string) => {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      const lowerCaseValue = value.toLowerCase();
      if (lowerCaseValue === "yes" || lowerCaseValue === "true") {
        return true;
      }
      if (
        lowerCaseValue === "no" ||
        lowerCaseValue === "false" ||
        lowerCaseValue === ""
      ) {
        return false;
      }
    }

    return Boolean(value);
  };
  const [isProvisional, setIsProvisional] = useState(true);
  const handleSubmit = (event: any) => {
    event.preventDefault();

    if (sessionDate && sessionDate < minSessionDate) {
      toast({
        position: "top",
        title: "Booking Validation",
        description: `Session date cannot be earlier than ${DateTime.fromISO(
          minSessionDate
        ).toFormat("dd LLL yyyy")}.`,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const leadSymptoms = symptoms.map((el: { value: any }) => el.value);
    const therapyInfo = { ...therapyInformation, symptoms: leadSymptoms };
    const data = {
      ...bookingDetails,
      non_app: isProvisional,
      session_date: formattedDate(sessionDate),
      session_date_iso: sessionDate,
      session_time: formattedTime(sessionTime),
      session_date_time: DateTime.fromISO(
        `${sessionDate}T${sessionTime}`,
      ).toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS"),

      booking_date: formattedDate(bookingDate),
      booking_time: bookingTime,
      payment_information: paymentInformation,
      lead_information: leadInformation,
      expert_information: expertInformation,
      cart_information: cartInformation,
      subscription: {
        ...subscriptionInformation,
      },
      manoshala_pro: manoProInformation,
      therapy_plus: therapyPlusInformation,
      therapy_note: therapyInfo,
      physical_session_address: physicalInformation,
      expert_billing_details: {
        isCorporate: isCorporate === "yes" ? true : false,
        booking_source: source,
      },
      post_session_status: bookingPostStatus,
    };
    // console.log(data);
    BookingDataService.updateBooking(data, id)
      .then((response: any) => {
        navigate(`/bookings/view/${id}`);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  const handleExpertDetails = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setExpertInformation({
        ...expertInformation,
        uuid: value,
        full_name: data.data.full_name,
        role: data.data.role,
      });
    } else {
      setExpertInformation({
        uuid: "",
        full_name: "",
        role: "",
      });
    }
  };
  const fetchExperts = () => {
    ExpertDataService.getExperts(token)
      .then((res: any) => {
        setExpertList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const fetchData = () => {
    BookingDataService.getSingleBooking(id)
      .then((response: any) => {
        const data = response.data;
        const { _id, createdAt, updatedAt, ...rest } = data;
        setBookingDetails({
          ...rest,
          //   is_subscription: booleanToYesNo(data.is_subscription),
        });
        setSessionDate(convertDateFormat(data.session_date));
        setSessionTime(convertTo24HourFormat(data.session_time));
        setBookingDate(convertDateFormat(data.booking_date));
        setBookingTime(data.booking_time);
        setPaymentInformation({ ...data.payment_information });
        setLeadInformation({ ...data.lead_information });
        setExpertInformation({ ...data.expert_information });
        setCartInformation({
          ...data.cart_information,
        });
        setIsProvisional(data.non_app);
        setIsCorporate(
          data.expert_billing_details.isCorporate === "true" ? "yes" : "no",
        );
        setSource(data.expert_billing_details.booking_source);
        setSessionCount(data.subscription.session_count);
        setSubscriptionInformation({ ...data.subscription });
        setManoProInformation({ ...data.manoshala_pro });
        setTherapyPlusInformation({ ...data.therapy_plus });
        setBookingPostStatus(data.post_session_status);

        setSymptoms(
          Issues.filter((issue) =>
            data.therapy_note.symptoms.includes(issue.value),
          ),
        );
        setTherapyInformation({
          ...data.therapy_note,
          age: String(data.therapy_note.age),
        });

        setphysicalInformation({ ...data.physical_session_address });
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const allowedEmails = [
    "tamannar@manoshala.com",
    "ceooffice@manoshala.com",
    "ayushs@manoshala.com",
  ];

  const isLoggedInUserAllowed =
    loggedInUserEmail !== null && allowedEmails.includes(loggedInUserEmail);

  const handleSwitchChange = (event: any) => {
    setIsProvisional(event.target.checked);
  };

  useEffect(() => {
    fetchExperts();
    fetchData();
  }, []);
  return (
    <div className="main-wrapper p-3">
      <div className="container-fluid bg-white rounded p-5">
        <div className="row m-0 justify-content-center">
          <h1 className="mb-4">Provisional Booking</h1>
          <div className="card p-5 col-lg-10">
            <h2>Basic Info</h2>
            <FormControl display="flex" alignItems="center">
              <FormLabel htmlFor="email-alerts" mb="5" mt="5">
                Is Provisional Booking?
              </FormLabel>
              <Switch
                id="email-alerts"
                isChecked={isProvisional}
                onChange={handleSwitchChange}
                isDisabled={!isLoggedInUserAllowed}
              />
            </FormControl>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_date">
                    Booking Date
                  </label>
                  <input
                    value={bookingDate}
                    onChange={handleBookingDateChange}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    name="booking_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Booking Time
                  </label>
                  <input
                    value={bookingTime}
                    onChange={handleBookingTimeChange}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    name="booking_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Date
                  </label>
                  <input
                    value={sessionDate}
                    onChange={handleSessionDateChange}
                    type="date"
                    className="form-control"
                    id="session_date"
                    name="session_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Time
                  </label>
                  <input
                    value={sessionTime}
                    onChange={handleSessionTimeChange}
                    type="time"
                    className="form-control"
                    id="session_time"
                    name="session_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Session Type
                  </label>
                  <select
                    name="session_type"
                    value={bookingDetails.session_type}
                    onChange={handleChange}
                    className="form-control"
                    id="session_type"
                  >
                    <option value="">Select Session Type</option>
                    <option value="personal">Personal</option>
                    <option value="couple">Couple</option>
                    <option value="family">Family</option>
                    <option value="child">Child</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Type
                  </label>
                  <select
                    required
                    name="booking_type"
                    value={bookingDetails.booking_type}
                    onChange={handleChange}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Session Type</option>
                    <option value="couple">Couple</option>
                    <option value="inperson">Inperson</option>
                    <option value="video">Video</option>
                    <option value="call">Call</option>
                    <option value="chat">Chat</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Session Count
                  </label>
                  <select
                    required
                    name="session_count"
                    value={sessionCount}
                    onChange={(e) => setSessionCount(e.target.value)}
                    className="form-control"
                    id="session_count"
                  >
                    <option value="">Select </option>
                    <option value="1">1</option>
                    <option value="3">3</option>
                    <option value="5">5</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Status
                  </label>
                  <select
                    name="booking_status"
                    value={bookingDetails.booking_status}
                    onChange={handleChange}
                    className="form-control"
                    id="booking_status"
                  >
                    <option value="">Select</option>
                    <option value="BOOKED">Booked</option>
                    <option value="RESCHEDULED">Resheduled</option>
                    <option value="CANCELLED">Canceled</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Post Booking Status
                  </label>
                  <select
                    value={bookingPostStatus}
                    name="booking_type"
                    onChange={(e) => setBookingPostStatus(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select </option>
                    <option value="NO_SHOW">No Show</option>
                    <option value="SUCCESSFUL">Successful</option>
                    <option value="RESCHEDULED">Rescheduled</option>
                    <option value="PARTIAL_SESSION">Partial Session</option>
                    <option value="EXPERT_LEVEL_ISSUE">
                      Expert Level Issue
                    </option>
                    <option value="USER_LEVEL_ISSUE">User Level Issue</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Session Duration
                  </label>
                  <input
                    value={bookingDetails.session_duration}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="session_duration"
                    name="session_duration"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Select Expert
                  </label>
                  <Select
                    id="expert"
                    name="expert"
                    options={options}
                    placeholder="Choose Expert"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === expertInformation.uuid,
                    )}
                    onChange={(option: any) =>
                      handleExpertDetails(option ? option.value : null)
                    }
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Source
                  </label>
                  <select
                    required
                    name="booking_type"
                    value={source}
                    onChange={(e) => setSource(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Source</option>
                    <option value="APP">App</option>
                    <option value="WIX">Wix</option>
                    <option value="OTHER">Other</option>
                    {/* <option value="chat">Chat</option> */}
                  </select>
                </div>

                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Is Corporate?
                  </label>
                  <select
                    name="booking_type"
                    value={isCorporate}
                    onChange={(e) => setIsCorporate(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Source</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                {/* <h2 className="form-group col-md-12 mb-4">
                  Physical Session Address
                </h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Address
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    City
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="gender">
                    State
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="state">
                    Pin Code
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="pin_code"
                    name="pin_code"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Latitude
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="latitude"
                    name="latitude"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    Longitude
                  </label>
                  <input
                    onChange={handlePhysicalSessionChange}
                    type="text"
                    className="form-control"
                    id="longitude"
                    name="longitude"
                  />
                </div> */}

                <h2 className="form-group col-md-12 mb-4">Cart Information</h2>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Promo Code
                  </label>
                  <input
                    value={cartInformation.promocode}
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="promocode"
                    name="promocode"
                  />
                </div>
                {/* <div className="form-group col-md-3 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Subscription
                  </label>
                  <select
                    name="subscription"
                    onChange={handleCartChange}
                    className="form-control"
                    id="subscription"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="form-group col-md-3 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Pro
                  </label>
                  <select
                    name="pro"
                    onChange={handleCartChange}
                    className="form-control"
                    id="pro"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div> */}
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Original Price
                  </label>
                  <input
                    value={cartInformation.original_price}
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="original_price"
                    name="original_price"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Final Price
                  </label>
                  <input
                    value={cartInformation.final_price}
                    onChange={handleCartChange}
                    type="text"
                    className="form-control"
                    id="final_price"
                    name="final_price"
                  />
                </div>
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Subscription Info
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Count
                  </label>
                  <input
                    onChange={handleSubscriptionChange}
                    type="text"
                    className="form-control"
                    id="session_count"
                    name="session_count"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Price
                  </label>
                  <input
                    onChange={handleSubscriptionChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div> */}
                <h2 className="form-group col-md-12 mb-4"> Lead Information</h2>
                {/* <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Uuid
                  </label>
                  <input
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="uuid"
                    name="uuid"
                  />
                </div> */}
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    First Name
                  </label>
                  <input
                    value={leadInformation.first_name}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="first_name"
                    name="first_name"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Last Name
                  </label>
                  <input
                    value={leadInformation.last_name}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="last_name"
                    name="last_name"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Email
                  </label>
                  <input
                    value={leadInformation.email}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Phone
                  </label>
                  <input
                    value={leadInformation.phone}
                    onChange={handleLeadChange}
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Age
                  </label>
                  <input
                    value={therapyInformation.age}
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Gender
                  </label>
                  <input
                    value={therapyInformation.gender}
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="gender"
                    name="gender"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Symptoms
                  </label>
                  <MultiSelect
                    options={Issues}
                    labelledBy="Select Symptoms"
                    value={symptoms}
                    onChange={setSymptoms}
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Notes
                  </label>
                  <input
                    value={therapyInformation.notes}
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="notes"
                    name="notes"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Comment
                  </label>
                  <input
                    value={bookingDetails.comment}
                    onChange={handleChange}
                    name="comment"
                    type="text"
                    className="form-control"
                    id="comment"
                  />
                </div>
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Expert Information
                </h2>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Uuid
                  </label>
                  <input
                    onChange={handleExpertChange}
                    type="text"
                    className="form-control"
                    id="uuid"
                    name="uuid"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Full Name
                  </label>
                  <input
                    onChange={handleExpertChange}
                    type="text"
                    className="form-control"
                    id="full_name"
                    name="full_name"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Role
                  </label>
                  <select
                    name="role"
                    onChange={handleExpertChange}
                    className="form-control"
                    id="role"
                  >
                    <option value="">Select Role</option>
                    <option value="clinical_psychologist">
                      Clinical Psychologist
                    </option>
                    <option value="psychiatrist">Psychiatrist</option>
                    <option value="counseling_psychologist">
                      Counseling Psychologist
                    </option>
                    <option value="creative_art_therapist">
                      Creative Art Therapist
                    </option>
                    <option value="yoga_or_meditation_expert">
                      Yoga or Meditation Expert
                    </option>
                  </select>
                </div> */}
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Payment Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Amount
                  </label>
                  <input
                    onChange={handlePaymentChange}
                    type="text"
                    className="form-control"
                    id="amount"
                    name="amount"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Payment Id
                  </label>
                  <input
                    onChange={handlePaymentChange}
                    type="text"
                    className="form-control"
                    id="payment_id"
                    name="payment_id"
                  />
                </div>
                <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Manoshala PRO Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Term Length
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="term_length"
                    name="term_length"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Price
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Module Name
                  </label>
                  <input
                    onChange={handleProChange}
                    type="text"
                    className="form-control"
                    id="module"
                    name="module"
                  />
                </div>
                <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Therapy Plus Information
                </h2>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Term Length
                  </label>
                  <input
                    onChange={handleTherapyPlusChange}
                    type="text"
                    className="form-control"
                    id="term_length"
                    name="term_length"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Price
                  </label>
                  <input
                    onChange={handleTherapyPlusChange}
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                  />
                </div> */}
                {/* <h2 className="form-group col-md-12 mb-4">
                  {" "}
                  Therapy Note Information
                </h2> */}
                {/* <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Age
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Gender
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="gender"
                    name="gender"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Symptoms
                  </label>
                  <MultiSelect
                    options={Issues}
                    labelledBy="Select Symptoms"
                    value={symptoms}
                    onChange={setSymptoms}
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Notes
                  </label>
                  <input
                    onChange={handleTherapyChange}
                    type="text"
                    className="form-control"
                    id="notes"
                    name="notes"
                  />
                </div> */}
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
